import { render, staticRenderFns } from "./MerchantCommission.vue?vue&type=template&id=e4323a0c&scoped=true&"
import script from "./MerchantCommission.vue?vue&type=script&lang=js&"
export * from "./MerchantCommission.vue?vue&type=script&lang=js&"
import style0 from "./MerchantCommission.vue?vue&type=style&index=0&id=e4323a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4323a0c",
  null
  
)

export default component.exports